export const socialsData = {
    github: 'https://github.com/NoobDev008/',
    facebook: 'https://www.facebook.com/shubhamsrivastava008/',
    linkedIn: 'https://www.linkedin.com/in/developershubham008/',
    instagram: 'https://www.instagram.com/imshubham_008/',
    codepen: 'https://codepen.io/shubh_008',
    twitter: 'https://twitter.com/Shubham64333977',
    medium: 'https://medium.com/@shubhamsri0807',

}